ACC.reactHybrisLogin = {

    _autoload: ['init'],

    init() {
        if (!document.querySelectorAll('#react-login').length) { return; }
        const {
            mountComponent,
            triggerIESSignInModal,
            handleIESSuccessSignIn,
            handleIESFailureSignIn,
            handleIESSuccessSignUp,
            handleIESFailureSignUp,
        } = ACC.reactHybrisLogin;

        piSession.initialize(ACC.config.iamClientId);

        mountComponent();

        document.getElementById('react-login-btn').addEventListener('click', triggerIESSignInModal);

        document.addEventListener('IESSuccessSignIn', handleIESSuccessSignIn);
        document.addEventListener('IESFailureSignIn', handleIESFailureSignIn);
        document.addEventListener('IESSuccessSignUp', handleIESSuccessSignUp);
        document.addEventListener('IESFailureSignUp', handleIESFailureSignUp);
    },

    triggerIESSignInModal() {
        console.log('requestIESSignInModal');
        document.dispatchEvent(new CustomEvent('requestIESSignInModal'));
    },

    handleIESFailureSignIn(e) {
        console.log(e, 'IESFailureSignIn');
    },

    handleIESSuccessSignIn(e) {
        console.log(e, 'IESSuccessSignIn');
        ACC.iamActions.triggerHybrisLogin($('#loginReferer').val() || document.referrer, 'account.success.login');
    },

    handleIESFailureSignUp(e) {
        console.log(e, 'IESFailureSignUp');
    },

    handleIESSuccessSignUp(e) {
        console.log(e, 'IESSuccessSignUp');
        ACC.reactHybrisLogin.sendCreateAccountSiftEvent(e.detail.originalEvent);
        ACC.iamActions.triggerHybrisLogin($('#loginReferer').val() || document.referrer, 'account.success.login');
    },

    mountComponent() {
        document.dispatchEvent(new CustomEvent('requestMountIESModalApp', {
            detail: {
                mountElement: document.getElementById('react-login'),
            },
        }));
    },

    sendCreateAccountSiftEvent(payload) {
        const apiURL = ACC.reactHybrisLogin.getProp('sift-api-url');
        const params = JSON.stringify(ACC.reactHybrisLogin.getCreateAccountBody(payload));
        const token = ACC.upcConsents.getPiSessionToken();
        const headers = {
            'Content-Type': 'application/json',
        };
        if (token) {
            headers['X-Authorization'] = token;
        }
        fetch(apiURL, {
            method: 'POST',
            headers,
            body: params,
        }).then((response) => {
            console.log(response);
        }).catch((e) => {
            console.log(e);
        });
    },

    getCreateAccountBody(payload = {}) {
        const { userAgent } = window.navigator;
        const email = (payload.username || '').toLowerCase();
        const brandName = ACC.reactHybrisLogin.getProp('brand_name');
        const siteDomain = window.location.host;
        const siteCountry = ACC.config.countrySpecificCode;
        const apiKey = ACC.reactHybrisLogin.getProp('sift-api-key');

        const params = {
            $api_key: apiKey,
            $type: '$create_account',
            $user_id: email,
            $user_email: email,
            $session_id: ACC.cookie.getCookie('sift_cookie'),
            $brand_name: brandName,
            site: `Learner ${siteCountry} Site`,
            $site_domain: siteDomain,
            $site_country: siteCountry,
            $browser: {
                $user_agent: userAgent,
                $content_language: `en-${siteCountry}`,
                $accept_language: `en-${siteCountry},en;q=0.9`,
            },
        };
        return params;
    },
    getProp(prop) {
        const result = globalProperties.globalProperties.find((x) => {
            if (x[prop]) {
                return true;
            }
            return false;
        });
        return result[prop];
    },
};
